exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-section[data-v-2590dafc]{padding:26px 0 60px;border-bottom:2px solid #e5e5e5}@media (max-width:640px){.title-section[data-v-2590dafc]{padding:30px 0}}.title-section .content-max-width>[data-v-2590dafc]:last-child{margin-bottom:0!important}.title-section h1[data-v-2590dafc]{font-size:30px;font-weight:400;letter-spacing:.2px;line-height:42px;color:#404042}.title-section p[data-v-2590dafc]{max-width:770px;width:100%;margin:0;font-size:16px;letter-spacing:.6px;line-height:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2590dafc","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/components/PageTitle.vue
// module id = 1j+D
// module chunks = 1